import React from "react";
import styled, { css } from "styled-components";
import cx from "classnames";
import { useFormikContext } from "formik";
import { PrefillRadioGroup } from "./prefillRadioGroup";
import { createOption } from "../../constants/options";
import { AnimatedToggle } from "../animatedHeight";
import { usePendingPrefill, useSetDefaultValue } from "../../hooks";
import { otherDetailInputPaddingMixin } from "../../containers/Forms/components/formLayout/otherDetailsFocusWell";

const Wrapper = styled.div.attrs((props) => ({
  className: cx({expanded: props.expanded})
}))(({ theme }) => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  
  &:not(:last-of-type) {
    border-bottom: solid 1px ${theme.palette.main.border};
  }

  .details-content, .radio-group-container {
    transition: 0.2s cubic-bezier(0.85, 0, 0.15, 1);
  }
  
  &.expanded {
    .details-content, .radio-group-container {
      background-color: ${theme.palette.main.fieldWell};
    }
  }
  
  &:first-of-type {
    .details-content {
      border-top-left-radius: ${theme.borderRadii.medium};
      border-top-right-radius: ${theme.borderRadii.medium};

      @media only screen and (min-width: ${theme.breakpoints.M}) {
        border-top-right-radius: unset;
      }
    }

    .radio-group-container {
      @media only screen and (min-width: ${theme.breakpoints.M}) {
        border-top-right-radius: ${theme.borderRadii.medium};
      }
    }
  }

  .details-content {
    flex: 1;
    font-size: 16px;
    line-height: 1.56;
    padding-top: 20px;
    padding-bottom: 12px;
    ${otherDetailInputPaddingMixin}

    span {
      display: block;
      color: ${theme.palette.main.secondary};
      font-weight: ${theme.fonts.headingWeight};
    }

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      line-height: 1.88;
      padding-right: unset;
      min-height: 124px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  
  & > .radio-group-container {
    display: flex;
    flex-direction: column;
    flex: 0 0 100%;
    box-sizing: border-box;
    padding-bottom: 19px;
    ${otherDetailInputPaddingMixin}
    @media only screen and (min-width: ${theme.breakpoints.M}) {
      justify-content: center;
      flex-basis: 235px;
      padding-left: unset;
      padding-bottom: unset;
    }
  }
  
  & > .toggle-contents {
    flex: 1 0 100%;
    box-sizing: border-box;
    ${otherDetailInputPaddingMixin}

    & > [data-toggle-container] {
      &:before {
        display: block;
        content: "";
        height: 23px;
        @media only screen and (min-width: ${theme.breakpoints.M}) {
          height: 27px;
        }
      }
    }
  }
`);

export const DetailsChangedInput = ({ labelTitle, labelDetail, children, name }) => {
  const { values } = useFormikContext();
  const value = values[name];
  const isExpanded = value === "false";

  useSetDefaultValue(name, "true");
  usePendingPrefill(name);

  return (
    <Wrapper expanded={isExpanded}>
      <p className="details-content">
        {labelTitle}
        <span>{labelDetail}</span>
      </p>
      <PrefillRadioGroup
        name={name}
        combined
        className="radio-group-container"
        options={[createOption("YES", "true"), createOption("NO", "false")]}
      />
      <AnimatedToggle outerProps={{className: "toggle-contents"}} show={isExpanded}>
        {children}
      </AnimatedToggle>
    </Wrapper>
  );
}